import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, ClipboardList, HeartHandshake } from "lucide-react";
import { company } from "../mock";

const MobileCtaBar = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/owner")) return null;
  return (
    <div data-testid="mobile-cta-bar" className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-slate-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]">
      <div className="grid grid-cols-3">
        <a href={`tel:${company.phoneRaw}`} data-testid="mobile-cta-call" className="flex flex-col items-center gap-0.5 py-2.5 text-[#0E5A72] font-semibold text-xs">
          <Phone className="h-5 w-5" /> CALL
        </a>
        <Link to="/refer" data-testid="mobile-cta-refer" className="flex flex-col items-center gap-0.5 py-2.5 text-white font-semibold text-xs bg-[#0E5A72]">
          <ClipboardList className="h-5 w-5" /> REFER
        </Link>
        <Link to="/contact" data-testid="mobile-cta-request" className="flex flex-col items-center gap-0.5 py-2.5 text-[#23875A] font-semibold text-xs">
          <HeartHandshake className="h-5 w-5" /> REQUEST CARE
        </Link>
      </div>
    </div>
  );
};

export default MobileCtaBar;
